import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";
import { isActiveLink } from "@/components/sidebar-items";
import type { SidebarGroupDef } from "@/components/sidebar-items";
import React from "react";

interface SidebarSettingsPanelProps {
  settingsGroups: SidebarGroupDef[];
  onBackToApp: (e: React.MouseEvent) => void;
  pathname: string;
  search: string;
}

/**
 * Settings navigation panel for the sidebar, showing a back button
 * and grouped settings items.
 */
export function SidebarSettingsPanel({
  settingsGroups,
  onBackToApp,
  pathname,
  search,
}: SidebarSettingsPanelProps) {
  return (
    <div className="flex w-1/2 flex-col overflow-y-auto scrollbar-transparent">
      <SidebarGroup>
        <SidebarGroupContent>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton asChild>
                <Link to="/" onClick={onBackToApp}>
                  <ArrowLeft />
                  <span>Back to app</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>

      {settingsGroups.map((group) => (
        <SidebarGroup key={group.label}>
          <SidebarGroupLabel className="uppercase tracking-widest text-[10px] font-semibold">
            {group.label}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {group.items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    isActive={isActiveLink(item.url, pathname, search)}
                  >
                    <Link to={item.url}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </div>
  );
}
